import Ajax from 'js/utils/ajax/ajax.js';

export const resetPassword = (userId: number) =>
  Ajax.patch(`/useradmin/v1/users/${userId}/password`);
